export default "__VITE_ASSET__DSBURH0N__"